import { render, staticRenderFns } from "./ShortnimInfo.vue?vue&type=template&id=aac6c01c&scoped=true&"
import script from "./ShortnimInfo.vue?vue&type=script&lang=js&"
export * from "./ShortnimInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShortnimInfo.vue?vue&type=style&index=0&id=aac6c01c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac6c01c",
  null
  
)

export default component.exports